export default __webpack_public_path__ + "static/media/Silva.c90fb771.png";